import { Button } from '@brighterion/br-ui';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory, useParams } from 'react-router-dom';
import { handleOnClickEvent, handleKeyEvent } from 'Utils';
import styles from './AddOverrideBtn.css';

type Props = {
    id: string;
    showButton?: boolean;
    selectedRowId: string;
};

const AddOverrideBtn = ({ id, showButton, selectedRowId }: Props) => {
    const { t } = useTranslation();
    const history = useHistory();
    const { tenantGroupId } = useParams<{ tenantGroupId: string }>();

    const addOverride = () => {
        history.push(
            `/tenants/tenant-group/${tenantGroupId}/add-tenant-group-override/${id}?selectedRowId=${selectedRowId}`
        );
    };

    return (
        <div className={styles.container}>
            {showButton && (
                <Button
                    dataTestId='add-button'
                    variant='contextual-secondary'
                    onClick={handleOnClickEvent(addOverride)}
                    onKeyDown={handleKeyEvent(addOverride)}
                >
                    {t('Add Override')}
                </Button>
            )}
        </div>
    );
};

export default AddOverrideBtn;
